import { Controller } from '@hotwired/stimulus';

const OPERATION_MESSAGES = {
  release_to_clearance: '指定フォワーダーの名称、担当者名、連絡先（電話番号、メールアドレス）を備考欄にご記入ください。',
  flight: '現地配送を含めてご依頼いただく場合は、現地配送先欄に必要な情報をご記入ください。',
};

function getOperationMessage(checkedTarget) {
  if (!checkedTarget) return '';
  return OPERATION_MESSAGES[checkedTarget.value] || '';
}

export default class extends Controller {
  static targets = [
    'operation',
    'airportSelect',
    'airportField',
    'entrustedAirportButton',
    'deliveryToCompanyType',
    'deliveryToCompanyField',
    'flightSettlementMethodField',
    'deliveryToAddressField',
    'releaseMethodField',
    'releasedOnField',
    'riskAlert',
  ];

  connect() {
    this.changeOperationHandler();
    this.changeAirportHandler();
  }

  displayConditionalField(targetName) {
    if (this[`isEnable${targetName[0].toUpperCase() + targetName.slice(1)}`]()) {
      this.constructor.showTarget(this[`${targetName}Target`]);
    } else {
      this.constructor.hideTarget(this[`${targetName}Target`]);
    }
  }

  updateAirportFieldDisplay() {
    if (this.isEnableAirportField()) {
      this.constructor.showTarget(this.airportFieldTarget);
      if (this.isEnableEntrustedAirport()) {
        this.enableEntrustedAirportButton();
      } else {
        this.disableEntrustedAirportButton();
      }
    } else {
      this.constructor.hideTarget(this.airportFieldTarget);
    }
  }

  changeOperationHandler() {
    const checkedTarget = this.operationTargets.find((t) => t.checked);
    const message = getOperationMessage(checkedTarget);
    this.updateRiskAlert(message);
    this.displayConditionalField('releaseMethodField');
    this.displayConditionalField('releasedOnField');
    this.displayConditionalField('flightSettlementMethodField');
    this.displayConditionalField('deliveryToAddressField');
    this.updateAirportFieldDisplay();
  }

  updateRiskAlert(message) {
    this.riskAlertTargets.forEach((el) => {
      const title = el.querySelector('.title');
      if (message) {
        el.classList.remove('hidden');
        if (title) title.innerHTML = message;
      } else {
        el.classList.add('hidden');
      }
    });
  }

  isEnableReleaseMethodField() {
    const checkedTarget = this.operationTargets.find((target) => target.checked);
    return (
      checkedTarget
      && ['release_to_clearance', 'release_to_flight', 'release_to_delivery'].includes(checkedTarget.value)
    );
  }

  isEnableReleasedOnField() {
    const checkedTarget = this.operationTargets.find((target) => target.checked);
    return (
      checkedTarget
      && ['release_to_clearance', 'release_to_flight', 'release_to_delivery'].includes(checkedTarget.value)
    );
  }

  isEnableAirportField() {
    const checkedTarget = this.operationTargets.find((target) => target.checked);
    return (
      checkedTarget
      && ['release_to_flight', 'release_to_delivery', 'flight'].includes(checkedTarget.value)
    );
  }

  isEnableEntrustedAirport() {
    const checkedTarget = this.operationTargets.find((target) => target.checked);
    return (
      checkedTarget
      && ['release_to_delivery', 'flight'].includes(checkedTarget.value)
    );
  }

  isEnableFlightSettlementMethodField() {
    const checkedTarget = this.operationTargets.find((target) => target.checked);
    return (
      checkedTarget
      && ['release_to_flight', 'release_to_delivery', 'flight'].includes(checkedTarget.value)
    );
  }

  isEnableDeliveryToAddressField() {
    const checkedTarget = this.operationTargets.find((target) => target.checked);
    return (
      checkedTarget
      && ['release_to_delivery', 'flight'].includes(checkedTarget.value)
    );
  }

  static showTarget(target) {
    target.classList.remove('hidden');
  }

  static hideTarget(target) {
    target.classList.add('hidden');
  }

  disableEntrustedAirportButton() {
    this.entrustedAirportButtonTarget.checked = false;
    this.entrustedAirportButtonTarget.disabled = true;
  }

  enableEntrustedAirportButton() {
    this.entrustedAirportButtonTarget.disabled = false;
  }

  changeAirportHandler() {
    this.updateCompanyType();
  }

  updateCompanyType() {
    const select = this.airportSelectTarget;
    const option = select.options[select.selectedIndex];
    const eu = option.getAttribute('data-eu');
    const code = option.getAttribute('data-code');

    if (eu === 'true') {
      this.constructor.showTarget(this.deliveryToCompanyFieldTarget);
      this.deliveryToCompanyTypeTarget.value = 'EORI CODE';
    } else if (code) {
      this.constructor.showTarget(this.deliveryToCompanyFieldTarget);
      this.deliveryToCompanyTypeTarget.value = code;
    } else {
      this.constructor.hideTarget(this.deliveryToCompanyFieldTarget);
    }
  }
}
